import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles({
  container: {
    textAlign: 'center',
    width: '100%',
    height: '100%',
  },
});
